import { useEffect } from 'react';
import axios from 'axios';
import { toast } from '@/components/ui/sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LEGACY_KEY = 'manualHours';
const SENT_KEY = 'manualHours_recovery_sent_v1';

function deviceId() {
  let id = localStorage.getItem('dlv_device_id');
  if (!id) {
    id = `poste_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
    localStorage.setItem('dlv_device_id', id);
  }
  return id;
}

// Transmet une fois (et à chaque changement) les anciennes heures locales du Calcul salaire ; la copie locale n'est jamais effacée.
export function useLegacyHoursRecovery(user) {
  useEffect(() => {
    if (user?.role !== 'admin') return;
    let raw;
    try { raw = localStorage.getItem(LEGACY_KEY); } catch (e) { return; }
    if (!raw || raw === '{}') return;
    const sentFor = localStorage.getItem(SENT_KEY);
    if (sentFor === `${user.user_id}:${raw.length}:${raw.slice(0, 64)}`) return;
    let entries;
    try { entries = JSON.parse(raw); } catch (e) { return; }
    axios.post(`${API}/schedule/integrity/legacy-manual-hours`, { device_id: deviceId(), entries }, { withCredentials: true })
      .then((res) => {
        localStorage.setItem(SENT_KEY, `${user.user_id}:${raw.length}:${raw.slice(0, 64)}`);
        if (res.data?.new_entries) {
          toast.info(`${res.data.new_entries} heure(s) saisie(s) autrefois sur cet ordinateur ont été transmises au Super Admin pour rapprochement (rien n'a été modifié).`, { duration: 10000 });
        }
      })
      .catch(() => {});
  }, [user?.role, user?.user_id]);
}
